import script from "./AdminProductEditPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminProductEditPage.vue?vue&type=script&setup=true&lang=ts"

import "./AdminProductEditPage.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__